<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>
      <v-card-title>Are you sure?</v-card-title>
      <v-card-text>
        <p>Are you sure you want to convert this product to Web2.0?</p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="convertProductToWebLoading" :loading="convertProductToWebLoading">CONFIRM</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions } from "vuex";
  export default {
    props: ['dialogOpen'],
    computed: {
      ...mapState('productWebsite',['convertProductToWebLoading']),
    },
    methods: {
      ...mapActions('productWebsite',['convertProductToWeb']),
      async submit() {
        let success = await this.convertProductToWeb();
        if(success){ window.location.reload(); }
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
